/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Sync_In_ProgressInputs */

const en_error_sync_in_progress = /** @type {(inputs: Error_Sync_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A sync of this linesheet is still in progress: wait for its outcome.`)
};

/**
* | output |
* | --- |
* | "A sync of this linesheet is still in progress: wait for its outcome." |
*
* @param {Error_Sync_In_ProgressInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_sync_in_progress = /** @type {((inputs?: Error_Sync_In_ProgressInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Sync_In_ProgressInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_sync_in_progress(inputs)
});